import { environment } from '../../../environments/environment';

export class B2cAuthority {
  login = environment.production ? window['jupiter'].authority : environment.authority;
  get passwordReset() {
    return this.login.toLocaleLowerCase().replace('b2c_1a_signupsigninlsg', 'b2c_1a_passwordchange');
  }
}

export class B2cConfig {
  static readonly clientId = environment.production ? window['jupiter'].clientID : environment.clientID;
  static readonly authority = new B2cAuthority();
  static readonly scopes = ["openid", "profile"];
}
